var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-td"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.editStoreUser}},[_c('a-icon',{attrs:{"icon":"Edit"}}),_c('span',{staticClass:"ml-1"},[_vm._v(" Edytuj ")])],1),_c('store-users-delete-btn',{attrs:{"login":_vm.login,"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }